<template>
  <div class="layout-common">
    <div id="#topAnchor"></div>
    <!-- <gSwiper :arr="arr" :maxH="'inherit'"></gSwiper> -->
    <div class="register-result">
      <img style="width:100px" src="@assets/img/finish.png" class="icon">
      <div class="txt1">报名成功/Registration succeeded</div>

      <div class="txt2" v-if="mobile">
        <div>恭喜，{{ company }}，您已成功报名，您的报名回执已发送至展会联系人邮箱，请注意查收。</div>

         </br>
        <div class="center" style="width:100%">
        <div>感谢您申请参展{{ querys.exname }}！展位销售流程如下：</div>
        <div>第一步：销售人员按照展商申请的价位和面积数量进行初步规划（面积相同时，兼顾申请时序与参展历史），并和展商进行沟通，展商也可以和展区负责人建立联系，跟进销售进度。<a href="https://www.pharmchina.com.cn/page/contact" target="_blank">https://www.pharmchina.com.cn/page/contact</a></div>
         <div>第二步 确认展位后，请在规定时限内回签合同并全额付款，收到汇款后陆续开具增值税发票。</div>
          <div>第三步 登录立春网，精准填写企业信息、产品介绍、胸卡设计及会刊资料等。</div>
           <div>第四步 展前一月，我们将出具展位确认书。请仔细核对信息，打印盖章以备留存。此确认书为展商报到之关键凭证，敬请妥善保管。</div>
           </div>
            </br>

        <div class="center" v-if="querys">
          <div>您的展位预定信息:</div>
          <div>展会名称：{{ querys.exname }}</div>
          <div>展会时间：{{ time }}</div>
          <div>展会地点：{{ querys.excity }}</div>
          <div>申请企业名称：{{ company }}</div>
          <div>展区：{{ querys.exareaName }}</div>
          <div>展位类型：{{ querys.exareaType }}</div>
          <div>展位面积：{{ querys.exshowArea }}㎡</div>
          <div> 如有疑问，请下滑查看各展区销售负责人</div>
        </div>

      </div>

      <div class="txt2" v-if="!mobile">
        <div>恭喜，{{ company }}，您已成功报名，您的报名回执已发送至展会联系人邮箱，请注意查收。</div>
        </br>
        <div class="center" style="width:950px">
        <div>感谢您申请参展{{ querys.exname }}！展位销售流程如下：</div>
        <div>第一步：销售人员按照展商申请的价位和面积数量进行初步规划（面积相同时，兼顾申请时序与参展历史），并和展商进行沟通，展商也可以和展区负责人建立联系，跟进销售进度。<a href="https://www.pharmchina.com.cn/page/contact" target="_blank">https://www.pharmchina.com.cn/page/contact</a></div>
         <div>第二步 确认展位后，请在规定时限内回签合同并全额付款，收到汇款后陆续开具增值税发票。</div>
          <div>第三步 登录立春网，精准填写企业信息、产品介绍、胸卡设计及会刊资料等。</div>
           <div>第四步 展前一月，我们将出具展位确认书。请仔细核对信息，打印盖章以备留存。此确认书为展商报到之关键凭证，敬请妥善保管。</div>
           </div>
            </br>
        <div class="center" v-if="querys">
          <div>您的展位预定信息:</div>
          <div>展会名称：{{ querys.exname }}</div>
          <div>展会时间：{{ time }}</div>
          <div>展会地点：{{ querys.excity }}</div>
          <div>申请企业名称：{{ company }}</div>
          <div>展区：{{ querys.exareaName }}</div>
          <div>展位类型：{{ querys.exareaType }}</div>
          <div>展位面积：{{ querys.exshowArea }}㎡</div>
          <div> 如有疑问，请下滑查看各展区销售负责人</div>
        </div>

      </div>
      <div class="f-tac  btn">
        <Button type="primary" style='height: 70px;' size="large" @click="linkTo" v-if="mobile">返回官网</br>Return to the
          official website</Button>
        <Button type="primary" size="large" @click="linkTo" v-if="!mobile">返回官网/Return to the official website</Button>
      </div>

      <!-- <img src="@assets/img/qrCode.png" v-if="mobile">
      <div class="txt3M" v-if="mobile">官网微信</div> -->
      <!-- 手机 -->
      <div class="disFlex_cen" v-if="mobile">
        <div style=" width: 100%;
                    background: #FAFAFA;
                    padding: 20px;
                    height: 120px;">
          <div style="font-size: 12px;">
            <div class="disFlex_cen_mobile">
              <div class="">
                <img src="@assets/img/guoyao_gz.png">
                <div class="txt3_m">官方公众号/WeChat</div>
              </div>
              <div style="margin:0 10px">
                <img src="@assets/img/guoyao_xcx.png">
                <div class="txt3_m">官方小程序</div>
              </div>
              <div>
                <img src="@assets/img/guoyao_sp.png">
                <div class="txt3_m">官方视频号</div>
              </div>
              <div style="text-align: left;font-weight: bold;color: #333;font-size:12px;margin-left: 10px;">
                <div class="marTop">扫码关注</div>
                <div class="marTop">全国药品交易会官方平台,</div>
                <div class="marTop">更多精彩，为您呈现!</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- pc -->
      <div class="disFlex_cen" v-if="!mobile">
        <div style=" width: 600px;
                    background: #FAFAFA;
                    padding: 30px;
                    height: 170px;">
          <div class="disFlex_cen">
            <div class="">
              <img src="@assets/img/guoyao_gz.png">
              <div class="txt3">官方公众号/WeChat</div>
            </div>
            <div style="margin:0 20px">
              <img src="@assets/img/guoyao_xcx.png">
              <div class="txt3">官方小程序</div>
            </div>
            <div>
              <img src="@assets/img/guoyao_sp.png">
              <div class="txt3">官方视频号</div>
            </div>
            <div style="text-align: left;font-weight: bold;color: #333;font-size:16px;margin-left: 20px;">
              <div class="marTop">扫码关注</div>
              <div class="marTop">全国药品交易会官方平台,</div>
              <div class="marTop">更多精彩，为您呈现!</div>
            </div>
          </div>
        </div>
      </div>
      <div style="height:100px" v-if="!mobile"></div>
      <div style="height:50px" v-if="mobile"></div>

    </div>

    <!-- pc -->
    <div v-if="!mobile" style="margin: 0 auto;max-width: 1200px;">
      <div class="link">
        <div class="link-title">展位预定联系方式：</div>
        <Row :gutter="30">
          <Col span="8" v-for="(item, index) in linkQuery" :key="'query' + index">
          <div class="link-item">
            <div class="link-item_title">{{ item.title }}</div>
            <p v-if="item.name">{{ item.name }}</p>
            <p v-if="item.tel">电 话：{{ item.tel }}</p>
            <p v-if="item.phone">手 机：{{ item.phone }}</p>
            <!-- <p v-if="item.qq">QQ 号：{{ item.qq }}</p> -->
            <p v-if="item.email" class="under">{{ item.email }}</p>
          </div>
          </Col>
        </Row>
      </div>
      <!-- <div class="link">
        <div class="link-title">其他咨询联系方式：</div>
        <Row :gutter="30">
          <Col span="8" v-for="(item, index) in serviceQeury" :key="'query' + index">
          <div class="link-item">
            <div class="link-item_title">{{item.title}}</div>
            <p v-if="item.name">{{item.name}}</p>
            <p v-if="item.tel">电 话：{{item.tel}}</p>
            <p v-if="item.telOne">电 话：{{item.telOne}}</p>
            <p v-if="item.phone">手 机：{{item.phone}}</p>
            <p v-if="item.qq">QQ 号：{{item.qq}}</p>
            <p v-if="item.email" class="under">{{item.email}}</p>
          </div>
          </Col>
        </Row>
      </div> -->
    </div>

    <!-- 手机 -->
    <div style="padding: 10px;" v-if="mobile">
      <div style="margin: 0 auto;max-width: 100%;">
        <div class="link_m">
          <div class="link_m-title">展位预定联系方式：</div>
          <Row :gutter="12">
            <Col span="12" v-for="(item, index) in linkQuery" :key="'query' + index">
            <div class="link_m-item">
              <div class="link_m-item_title" style="font-size: 12px;">{{ item.title }}</div>
              <p v-if="item.name">{{ item.name }}</p>
              <p v-if="item.tel">电 话：{{ item.tel }}</p>
              <p v-if="item.phone">手 机：{{ item.phone }}</p>
              <!-- <p v-if="item.qq">QQ 号：{{ item.qq }}</p> -->
              <p v-if="item.email" class="under">{{ item.email }}</p>
            </div>
            </Col>
          </Row>
        </div>
        <!-- <div class="link_m">
          <div class="link_m-title">其他咨询联系方式：</div>
          <Row :gutter="12">
            <Col span="12" v-for="(item, index) in serviceQeury" :key="'query' + index">
            <div class="link_m-item" style="height: 175px;">
              <div class="link_m-item_title" style="font-size: 12px;">{{item.title}}</div>
              <p v-if="item.name">{{item.name}}</p>
              <p v-if="item.tel">电 话：{{item.tel}}</p>
              <p v-if="item.telOne">电 话：{{item.telOne}}</p>
              <p v-if="item.phone">手 机：{{item.phone}}</p>
              <p v-if="item.qq">QQ 号：{{item.qq}}</p>
              <p v-if="item.email" class="under">{{item.email}}</p>
            </div>
            </Col>
          </Row>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import gSwiper from "@components/gSwiper/gSwiper2.vue";
export default {
  name: 'register-result',
  components: {
    gSwiper,
  },
  data() {
    return {
      mobile: false,
      company: '',
      arr: [{ id: 1, path: require('../../../assets/img/banner.jpg') }],
      linkQuery: [
        { title: '化学药主厅/省市展团', name: '刘爽 女士', tel: '010 8455 6515', phone: '186 1256 2682', email: 'shuang.liu@reedsinopharm.com' },
        { title: '化学药/生物制品/医药研发供应链', name: '刘剑 先生', tel: '010 8455 6510', phone: '138 1030 9057', email: 'jian.liu@reedsinopharm.com' },
        { title: '中药主厅/中医药养生', name: '郭菲 女士', tel: '010 8455 6512', phone: '186 0112 6361', email: 'fei.guo@reedsinopharm.com' },
        { title: '中成药/中药材/中药饮片/配方颗粒/高增长渠道-第三终端专区', name: '王宁 先生', tel: '010 8455 6509', phone: '176 0080 5251', email: 'ning.wang@reedsinopharm.com' },
        { title: 'OTC/AI智慧医药/智慧营销/高增长渠道-新零售专区', name: '李维伟 女士', tel: '010 8455 6506', phone: '183 1015 0931', email: 'weiwei.li@reedsinopharm.com' },
        { title: '医用耗材/医疗器械/中医诊疗/医药物流技术与设备/医美健康/高增长渠道-院外生态专区', name: '陈文漪 女士', tel: '010 8455 6525', phone: '135 5205 4920', email: 'wenyi.chen@reedsinopharm.com' },
        { title: '国际、中国港澳台品牌/家用医疗器械/个人护理用品/成人用品展区', name: '姜文杰 先生', tel: '010 8455 6531', phone: '185 1065 0566', email: 'wenjie.jiang@reedsinopharm.com' },
        { title: '省市展团', name: '左芳萌 女士', tel: '010 8455 6517', phone: '135 2244 2707', email: 'fangmeng.zuo@reedsinopharm.com' },
      ],
      serviceQeury: [
        { title: '项目合作', name: '卫妍娜 女士', tel: '010-84556503', phone: '13911560268', email: 'yanna.wei@reedsinopharm.com' },
        { title: '云博会/商贸对接/数字化合作', name: '顾充 先生', tel: '01084556513', phone: '18611312950', email: 'chong.gu@reedsinopharm.com' },
        { title: '市场合作/参观咨询', name: '向婧洁 女士', tel: '01084556522', phone: '13717518515', email: 'jingjie.xiang@reedsinopharm.com' },
        { title: '会议咨询及合作', name: '姜雪丹 女士', tel: '01084556678', phone: '13810486580', email: 'xuedan.jiang@reedsinopharm.com' },
        { title: '媒体合作/活动合作', name: '孙惟阳 先生', tel: '01084556533', phone: '17800496786', email: 'weiyang.sun@reedsinopharm.com' },
        { title: '酒店预订请联系', name: '张颖 女士', tel: '01084556713', phone: '13021912124', email: 'ying.zhang@reedsinopharm.com' },
        { title: '指定主场搭建商', name: '韩京辉 先生', tel: '01084662670', phone: '18600078628', email: 'ome@bjome.com.cn' },
        { title: '大会指定主场承建商(特装施工申报)', name: '孙璐 先生', tel: '01084662797', telOne: '01084662728', phone: '18500428241', email: 'ome@bjome.com.cn' },
        { title: '大会指定主场承建商(普装参展商楣板登记、标准展台搭建变更)', name: '李响 先生', tel: '01084662719', telOne: '01084662176', email: 'ome@bjome.com.cn' },
        { title: '指定会刊 / 现场广告服务商(会刊广告 / 现场广告）', name: '杨爱莲 女士', tel: '01084662129', phone: '13810998733', email: '2126132665@qq.com' },
      ],
      querys: '',
      time: ''
    };
  },
  methods: {
    // //第二个功能，点击返回功能
    // onclick () {
    //         document.body.scrollTop = 0;
    //         document.documentElement.scrollTop = 0;
    //     },
    linkTo() {
      window.location.href = 'https://www.pharmchina.com.cn/';
    },

  },
  mounted() {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.mobile = true;
    }
    window.scrollTo(0, 0);
    const query = this.$route.query;
    this.company = query.company;
    this.querys = query;
    this.time = query.exstartTime.split('T')[0] + ' ~ ' + query.exendTime.split('T')[0];
    console.log('query', query);
  }
}

</script>

<style lang="scss" scoped>
.center {
  width: 360px;
  text-align: left;
  margin: 0 auto;
}

@media screen and (max-width: 600px) {
  .center {
    width: 100%;
  }
}

.layout-common {
  margin: 0 auto;
}

.register-result {
  width: 100%;

  text-align: center;

  .icon {
    display: block;
    margin: 80px auto 25px;
  }

  .txt1 {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
  }

  .txt2 {
    font-size: 16px;
    color: #333;
    margin-bottom: 25px;
    line-height: 1.8;
    padding: 20px;
  }

  .txt3 {
    font-size: 14px;
    color: #d00300;
    margin-bottom: 120px;
  }

  .txt3M {
    font-size: 14px;
    color: #333;
    margin-bottom: 120px;
  }
}

.btn {
  button {
    height: 48px;
    padding: 0 50px;
    background-color: #fff;
    font-size: 18px;
    border-radius: 5px;
    border: solid 1px #e5e5e5;
    margin-bottom: 80px;
    color: #333;
  }
}

.link {
  margin-bottom: 20px;

  &-title {
    font-size: 20px;
    color: #d00300;
    margin-bottom: 30px;
  }

  &-item {
    height: 220px;
    background-color: #fff;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 16px;
    color: #333;
    padding: 20px;
    margin-bottom: 30px;

    &_title {
      font-size: 16px;
      color: #d00300;
      margin-bottom: 20px;
    }

    p {
      line-height: 30px;
    }

    .under {
      text-decoration: underline;
    }
  }
}

.disFlex_cen {
  display: flex;
  justify-content: center;
  // align-items: center;
}

.disFlex_cen img {
  width: 84px;
  height: 84px;
}

.marTop {
  margin-top: 5px;
}

// 手机端
.disFlex_cen_mobile {
  display: flex;
  justify-content: center;
  // align-items: center;
}

.disFlex_cen_mobile img {
  width: 60px;
  height: 60px;
}

.txt3_m {
  font-size: 12px;
  color: #d00300;
  margin-bottom: 120px;
}

.link_m {
  margin-bottom: 20px;

  &-title {
    font-size: 16px;
    color: #d00300;
    margin-bottom: 10px;
  }

  &-item {
    height: 140px;
    background-color: #fff;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 12px;
    color: #333;
    padding: 10px;
    margin-bottom: 10px;

    &_title {
      font-size: 16px;
      color: #d00300;
      margin-bottom: 20px;
    }

    p {
      line-height: 20px;
    }

    .under {
      //   text-decoration: underline;
      white-space: normal;
      word-break: break-all;
    }
  }
}
</style>
